import styled from 'styled-components';
import { AlertStyled } from '../AlertStyled';

export const AlertStyledOV = styled(AlertStyled)`
    .wrapper {
        background: ${p => p.theme.colors.primary};
    }
`;
